import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Flex, Box, FormField, Label, AdornedInput, Adornment, Input, FormHelp, Paragraph, Slider } from '@zillow/constellation';

var rentAffordabilityInteractionTypes = {
  MONTHLY_NET_INCOME: 'monthly_net_income',
  MONTHLY_DEBTS: 'monthly_debts',
  MONTHLY_SAVINGS: 'monthly_savings',
  MONTHLY_EXPENSES: 'monthly_expenses',
  RENT_VALUE_SLIDER: 'rent_value_slider'
};
var RentAffordabilityCalculator = function RentAffordabilityCalculator(_ref) {
  var monthlyNetIncome = _ref.monthlyNetIncome,
    monthlyDebts = _ref.monthlyDebts,
    monthlySavings = _ref.monthlySavings,
    monthlyExpenses = _ref.monthlyExpenses;
  var _useState = useState({
      monthlyNetIncomePretax: 11600,
      monthlyNetIncome: monthlyNetIncome,
      monthlyDebts: monthlyDebts,
      monthlySavings: monthlySavings,
      monthlyExpenses: monthlyExpenses
    }),
    _useState2 = _slicedToArray(_useState, 2),
    incomeAndDebt = _useState2[0],
    setIncomeAndDebt = _useState2[1];
  var _useState3 = useState(Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.33)),
    _useState4 = _slicedToArray(_useState3, 2),
    rent = _useState4[0],
    setRent = _useState4[1];
  var _useState5 = useState({
      monthlyNetIncome: '',
      monthlyDebts: '',
      monthlySavings: '',
      monthlyExpenses: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var overBudget = incomeAndDebt.monthlyNetIncome - rent - incomeAndDebt.monthlyDebts - incomeAndDebt.monthlySavings - incomeAndDebt.monthlyExpenses < 0;
  var updateIncomeAndDebt = function updateIncomeAndDebt(e, type) {
    var updatedIncomeAndDebt = {};
    var updatedNetIncome;
    var updatedNetIncomePretax;
    var expenseValueValidity = '';
    var expenseValue = parseFloat(e.target.value);
    if (type === 'monthlyNetIncome') {
      if (!expenseValue) {
        expenseValueValidity = 'Please enter valid income value';
      }
      updatedNetIncome = expenseValue || 0;
      updatedNetIncomePretax = Math.round(updatedNetIncome / 0.75);
      updatedIncomeAndDebt = {
        monthlyNetIncomePretax: updatedNetIncomePretax,
        monthlyNetIncome: updatedNetIncome
      };
      setRent(Math.round(updatedNetIncomePretax * 0.33));
    }
    if (type === 'monthlyDebts' || type === 'monthlySavings' || type === 'monthlyExpenses') {
      var _updatedIncomeAndDebt;
      if (!expenseValue) {
        expenseValueValidity = 'Please enter valid expense value';
      }
      updatedIncomeAndDebt = (_updatedIncomeAndDebt = {}, _updatedIncomeAndDebt[type] = expenseValue || 0, _updatedIncomeAndDebt);
    }
    setIncomeAndDebt(function (prevState) {
      return Object.assign({}, prevState, updatedIncomeAndDebt);
    });
    setErrors(function (prevState) {
      var _Object$assign;
      return Object.assign({}, prevState, (_Object$assign = {}, _Object$assign[type] = expenseValueValidity, _Object$assign));
    });
  };
  var updateRent = function updateRent(e) {
    setRent(e);
  };
  var getCurrDisplayedFields = function getCurrDisplayedFields() {
    return [rentAffordabilityInteractionTypes.MONTHLY_NET_INCOME, incomeAndDebt.monthlyNetIncome, rentAffordabilityInteractionTypes.MONTHLY_DEBTS, incomeAndDebt.monthlyDebts, rentAffordabilityInteractionTypes.MONTHLY_SAVINGS, incomeAndDebt.monthlySavings, rentAffordabilityInteractionTypes.MONTHLY_EXPENSES, incomeAndDebt.monthlyExpenses];
  };
  var trackClickstreamInteraction = function trackClickstreamInteraction(interactionType) {
    handleClickstreamEvent(eventTypes.RENT_AFFORDABILITY_INTERACTION, interactionType, getCurrDisplayedFields());
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: {
      default: 'column',
      lg: 'row'
    },
    gap: "lg",
    justifyItems: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexShrink: 0,
    order: {
      default: 1,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '382px'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    flexDirection: "column",
    gap: "sm"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "Monthly net income"),
    error: errors.monthlyNetIncome !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "income-post-tax",
        placeholder: "Income after taxes",
        defaultValue: incomeAndDebt.monthlyNetIncome,
        maxLength: 10,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlyNetIncome');
        },
        onBlur: function onBlur() {
          return trackClickstreamInteraction(rentAffordabilityInteractionTypes.MONTHLY_NET_INCOME);
        }
      })
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, null, errors.monthlyNetIncome)
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "Monthly debts"),
    error: errors.monthlyDebts !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "monthly-debts",
        placeholder: "Credit cards, loans, ...",
        defaultValue: incomeAndDebt.monthlyDebts,
        maxLength: 7,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlyDebts');
        },
        onBlur: function onBlur() {
          return trackClickstreamInteraction(rentAffordabilityInteractionTypes.MONTHLY_DEBTS);
        }
      })
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, null, errors.monthlyDebts)
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, null, "Monthly Savings"),
    error: errors.monthlySavings !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "monthly-savings",
        placeholder: "Savings, 401k, ...",
        defaultValue: incomeAndDebt.monthlySavings,
        maxLength: 7,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlySavings');
        },
        onBlur: function onBlur() {
          return trackClickstreamInteraction(rentAffordabilityInteractionTypes.MONTHLY_SAVINGS);
        }
      })
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, null, errors.monthlySavings)
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, null, "Monthly Expenses"),
    error: errors.monthlyExpenses !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, null, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "monthly-expenses",
        placeholder: "Food, insurance, ...",
        defaultValue: incomeAndDebt.monthlyExpenses,
        maxLength: 7,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlyExpenses');
        },
        onBlur: function onBlur() {
          return trackClickstreamInteraction(rentAffordabilityInteractionTypes.MONTHLY_EXPENSES);
        }
      })
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, null, errors.monthlyExpenses)
  })))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: '382px',
      '@media $lg_gte': {
        width: 'auto'
      }
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    display: "flex",
    justifyItems: "center",
    alignItems: "center",
    gap: "md"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    display: "flex",
    justifyItems: "center",
    alignItems: "center",
    gap: "md",
    fontType: "h4"
  }, overBudget ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h4"
  }, "You're overbudget at"), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h2",
    fontColor: "red600"
  }, "$" + rent + "/mo")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h4"
  }, "You can afford"), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h2",
    fontColor: "backgroundDarkGreen"
  }, "$" + rent + "/mo"))), /*#__PURE__*/React.createElement(Slider, {
    id: "rent-value-slider",
    className: "rent-value-slider",
    min: Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.1),
    max: Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.4),
    value: rent,
    step: Math.round((incomeAndDebt.monthlyNetIncomePretax * 0.4 - incomeAndDebt.monthlyNetIncomePretax * 0.1) / 30),
    onChange: function onChange(e) {
      return updateRent(e);
    }
  }), /*#__PURE__*/React.createElement(Paragraph, {
    textAlign: "center"
  }, "Based on your income, a rental at this price should fin comfortably within your budget."), /*#__PURE__*/React.createElement(Paragraph, null, 'You will have ', /*#__PURE__*/React.createElement("strong", null, "$" + Math.round(incomeAndDebt.monthlyNetIncome - rent - incomeAndDebt.monthlyDebts - incomeAndDebt.monthlySavings - incomeAndDebt.monthlyExpenses) + " /mo"), ' left to spend.'), /*#__PURE__*/React.createElement(Paragraph, {
    textAlign: "center",
    fontType: "finePrint"
  }, "DISCLAIMER: The calculated output is just a suggestion. All personal and financial factors should be considered before signing a lease.")))));
};
var RentAffordabilityCalculator$1 = RentAffordabilityCalculator;

export { RentAffordabilityCalculator$1 as default };
